var map = {
	"./blackGold/header/copyIcon.png": 31105,
	"./brownGold/header/copyIcon.png": 25388,
	"./darkBlue/header/copyIcon.png": 69616,
	"./greenYellow/header/copyIcon.png": 93051,
	"./redGold/header/copyIcon.png": 62242,
	"./skyBlue/header/copyIcon.png": 9980,
	"./whiteGold/header/copyIcon.png": 94367,
	"./yellowWhite/header/copyIcon.png": 88878
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26136;